import React, { useEffect, useState } from "react";
import classes from "./ServicesComponents.module.scss";
import axios from "axios";
import { ReactComponent as CopyBtn } from "../../assets/copy.svg";
import LoadingDots from "../UI/LoadingDots";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const KeysContainer = () => {
  const [isLoading, setIsLoading] = useState(null);
  const [keys, setKeys] = useState(null);
  const [copied, setCopied] = useState({
    connTest: false,
    connProd: false,
    orgId: false,
  });

  const onCopyClickHandler = (item) => {
    setCopied((prev) => ({ ...prev, [item]: true }));
    if (item === "connTest") {
      navigator.clipboard.writeText(keys.connKeyTest);
    }

    if (item === "orgId") {
      navigator.clipboard.writeText(keys.AOrgID);
    }

    if (item === "connProd") {
      navigator.clipboard.writeText(keys.connKeyProd);
    }

    setTimeout(() => {
      setCopied((prev) => ({ ...prev, [item]: false }));
    }, 1500);
  };

  useEffect(() => {
    setIsLoading(true);
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.GetCurrentTData",
          },
          id: 5126,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res.data.result && res.data.result.Result) {
          setIsLoading(false);
          let resObj = res.data.result.Result;
          setKeys({
            orgId: resObj.AOrgID,
            connKeyTest: resObj.ConnectionKeyTest,
            connKeyProd: resObj.ConnectionKeyProd || null,
            isTrial: resObj.IsIrial,
          });
        }
      });
  }, []);

  const onGenerateProdKey = () => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Extension.Execute",
          params: {
            extension: "EUeInvoices.GenerateCKTDevice",
          },
          id: 264,
        },
        {
          withCredentials: true,
        }
      )
      .then((keyRes) => {
        if (keyRes.data.result) {
          setKeys((prev) => ({
            ...prev,
            connKeyProd: keyRes.data?.result?.Result?.Id,
          }));
        }
      });
  };

  return (
    <div className="mb-5">
      <h2 className={classes.subtitle}>API Keys</h2>
      {keys && !isLoading && (
        <>
          <div style={{ position: "relative", width: "fit-content" }}>
            <p>
              Your organisation ID is{" "}
              <button
                className={classes.accentText}
                onClick={() => onCopyClickHandler("orgId")}
              >
                {keys.orgId}
              </button>
            </p>
            {copied.orgId && <span className={classes.copiedMsg}>Copied!</span>}
          </div>
          <table className={classes.apiKeysTable}>
            <thead>
              <th>Mode</th>
              <th>API Key</th>
            </thead>
            <tbody>
              <tr>
                <td>TEST</td>
                <td
                  className={classes.copyKey}
                  onClick={() => onCopyClickHandler("connTest")}
                >
                  <button className={classes.connKeyBtn}>
                    {keys.connKeyTest}
                    <CopyBtn height="15" fill="#00436D" />
                  </button>
                  {copied.connTest && (
                    <span className={classes.copiedMsg}>Copied!</span>
                  )}
                </td>
              </tr>
              <tr>
                <td>PROD</td>
                <td>
                  {!keys.isTrial && keys.connKeyProd ? (
                    <button
                      className={`${classes.copyKey} ${classes.connKeyBtn}`}
                      onClick={() => onCopyClickHandler("connProd")}
                    >
                      {keys.connKeyProd}
                      <CopyBtn height="15" fill="#00436D" />
                      {copied.connProd && (
                        <span className={classes.copiedMsg}>Copied!</span>
                      )}
                    </button>
                  ) : (
                    <button
                      className={`${classes.orangeBtn} px-3`}
                      onClick={onGenerateProdKey}
                    >
                      Generate key
                    </button>
                  )}
                  {keys.isTrial && (
                    <p className={classes.grayText}>
                      Please switch to a paying plan in order to generate your
                      production key.
                    </p>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
      {isLoading && <LoadingDots />}
    </div>
  );
};

export default KeysContainer;
